import { BeadChip } from "./beadchip";
import { ProcessStep } from "./processStep";
import { Sample } from "./sample";
import { SourcePlate } from "./sourcePlate";
import {Comment} from "../models/comment";
import { RedoInformation } from "./redo-information";

export class Plate{
    plateID: string = "";
    labID: string = "";
    type: string = "";
    sender: string = "";
    pgxPlateID: string = "";
    wgaPlateID: string = "";
    lysisPlateID: string = "";
    dnaPlateID: string = "";
    magMixPlateID = "";
    aliquotPlateID: string = "";
    lastUpdatedPlateID: string = "";
    workflowID = "";
    workFlow: string = "";
    delivery: string = "";
    status: string = "";
    sampleType: string = "";
    completionTimeStamp?: Date;
    processFlowName: string = "";
    sourcePlates: Array<SourcePlate> = [];
    samples: Array<Sample> = [];
    processSteps: Array<ProcessStep> = [];
    beadChips: Array<BeadChip> = [];
    storagePlate: boolean = false;
    scanHorizontal: boolean = true;
    priority: number = 0;
    reRun: boolean = false;
    //If version is -1, plate is yet to be created, 0 means that the plate is created
    version = -1;
    projectID?: string = "";
    projectName?:string = "";
    dueDate?: Date;
    comments: Comment[];
    sendUpdateEvents:boolean = true;
    lastModifiedDate?: Date;
    adminChangeTimeStamp?: Date;
    latestUserComment?:Comment = null;
    plateType: string;
    batchID:  string;
    mergePlateIDs: string[];
    plates? : string[];
    hasRedoSamples?: boolean = false;
    redoInformation?: RedoInformation;
}
